import { useMutation, useQueryClient } from '@tanstack/react-query'
import api from '@/lib/api'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'
import { signatureUserKey } from '../helpers/signature-query-key'

export function useUpdateSignatureVerifedUser() {
  const queryClient = useQueryClient()
  const user = useCurrentUser()
  const token = useAccessToken()

  return useMutation({
    mutationFn: async ({ id_user, verifed }: { id_user: string; verifed: boolean }) => {
      if (!user || !token) throw new Error('Usuário não autenticado')

      const response = await api.post(`/signatures/isverifedUser/${id_user}/${verifed}`, null, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (!response.data) throw new Error('Erro ao atualizar assinatura')
      return response.data
    },
    onSuccess: (response, variables) => {
      const updatedSignature = response?.data

      if (updatedSignature) {
        queryClient.setQueryData(signatureUserKey(variables.id_user), updatedSignature)
      }

      queryClient.invalidateQueries({
        predicate: query =>
          typeof query.queryKey[0] === 'string' &&
          (query.queryKey[0] === 'signature' ||
            query.queryKey[0] === 'signature:user' ||
            query.queryKey[0] === 'signature:client')
      })
      queryClient.invalidateQueries({
        predicate: query => Array.isArray(query.queryKey) && query.queryKey[0] === 'agreement'
      })
    }
  })
}
